import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
} from '@mui/material';
import { useConfirmationModal } from '../../hooks/useConfirmationModal';

export const ConfirmationModal: React.FC = () => {
    const { modalState, hideConfirmationModal } = useConfirmationModal();

    const handleConfirm = () => {
        modalState.onConfirm();
        hideConfirmationModal();
    };

    return (
        <Dialog
            open={modalState.isOpen}
            onClose={hideConfirmationModal}
            maxWidth="xs"
            fullWidth
        >
            <DialogTitle>{modalState.title}</DialogTitle>
            <DialogContent>
                <Typography>{modalState.message}</Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={hideConfirmationModal} color="inherit">
                    İptal
                </Button>
                <Button onClick={handleConfirm} color="error" variant="contained">
                    Onayla
                </Button>
            </DialogActions>
        </Dialog>
    );
};